style= require('./receivers.styl')

.receivers-header
  header
    .count= 'Receivers'
      span= res.length
    .search
      ft-form-control(
        type="search",
        placeholder="Search receiver",
        (input)=this.filterReceivers(e)
      )
    .create
      ft-button(primary, (click)=this.createReceiver()) Create Receiver
.receivers
  .receivers-title
    .name Name
    .url URL
    .controls Remove from list
  if  this.res
    each receiver in res
      -let isInplay = receiver.isInplayFantasy ? '[IPF] ' : ''
      .entry
        .name
          span(style="color:gray;")=`${isInplay}`
          =receiver.name
        a.url(href=receiver.url, target="_blank")= receiver.url
        .controls
          .copy
            input(class='input', type="text",value=receiver.url,)
            ft-icon(name='ui--clipboard',(click)=this.copy(e))
          ft-button(transparent,(click)=this.remove(receiver)) Remove
